import B2ChatClient from '@client-sdk';
import { startFetchChatsOnHold } from '@src/sagas/chats';
import { isLoggedInSelect } from '@src/selectors/user';
// eslint-disable-next-line import/no-cycle
import { WebSocketEventTarget } from '@src/logic/websocketconnector';
import type { RootState } from '@src/store/reduxstore';
import type { ChatTray } from '@src/types/chats';
import { B2ChatAPI } from '@types-api';
import env from '@utils/env';
import { call, delay, select } from 'redux-saga/effects';

// TODO: patch — endpoint URL is inline, should be removed in the future
const PENDING_CHECK_URL = '/services/agent/chat/pending-check';

const CONSECUTIVE_REFRESH_THRESHOLD = 3;

type PendingCheckChat = { id: string; pending: number };
type PendingCheckResponse = { shouldRefresh: boolean };

function* periodicReconcileSaga() {
  let consecutiveRefreshCount = 0;

  while (true) {
    yield delay(60_000);

    if (document.visibilityState === 'visible') {
      const isLoggedIn: boolean = yield select(isLoggedInSelect);

      if (isLoggedIn) {
        const tray: ChatTray[] = yield select(
          (state: RootState) => state.chats.chatsOnHold.tray
        );

        if (tray?.length) {
          const chats: PendingCheckChat[] = tray.map(chat => ({
            id: chat.id,
            pending: chat.messagesSinceLastResponse,
          }));

          try {
            // TODO: patch — inline call, should be removed in the future
            const { data, error }: B2ChatAPI.Response<PendingCheckResponse> =
              yield call([B2ChatClient, B2ChatClient.call], {
                url: `${env.WEB_SERVICE_BASE_URI}${PENDING_CHECK_URL}`,
                method: 'POST' as const,
                options: { data: { chats } },
              });

            if (!error && data?.shouldRefresh) {
              consecutiveRefreshCount += 1;
              yield call(startFetchChatsOnHold, 0);

              if (consecutiveRefreshCount >= CONSECUTIVE_REFRESH_THRESHOLD) {
                WebSocketEventTarget.dispatchEvent(new Event('reconnect'));
                consecutiveRefreshCount = 0;
              }
            } else {
              consecutiveRefreshCount = 0;
            }
          } catch {
            consecutiveRefreshCount = 0;
          }
        }
      }
    }
  }
}

export default periodicReconcileSaga;
